import { render, staticRenderFns } from "./CoveragePageFormulaGoodwish.vue?vue&type=template&id=7e80d5ea"
import script from "./CoveragePageFormulaGoodwish.vue?vue&type=script&lang=js"
export * from "./CoveragePageFormulaGoodwish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports